import PgsfApi from '../../../common/api/pg-api';
import * as mutationsConst from '../mutations';

const state = () => ({
  contractedProducts: []
});

const mutations = {
  [mutationsConst.SET_CONTRACTED_PRODUCTS](state, products) {
    state.contractedProducts = products;
  }
};

const actions = {
  async setAlreadyContractedProducts({commit, rootState}, {sfId, affiliateId, products}) {
    return (new PgsfApi()).getAlreadyContractedProducts(sfId, affiliateId, products).then(response => {
      if (response.data.body.data) {
        commit(mutationsConst.SET_CONTRACTED_PRODUCTS, response.data.body.data);
        return;
      }

      console.log(response.data.body.message);
      // Don't redirect to error if the contactPolarisId doesnt exist
      // SUPPORT-43002
      // window.location = `${window.location.origin}/static/${rootState.locale}/error.html`;
    }).catch(error => {
      console.error(error);
      const locale = rootState && rootState.common && rootState.common.locale ? rootState.common.locale : 'fr';
      window.location = `${window.location.origin}/static/${locale}/error.html${document.location.search}`;
    });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/multiple/store/modules/products.js